import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

const siteUrl = 'https://gbwtsapp.com'

function canonical(path) {
	return `${siteUrl}${path}`
}

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Download APK V18.80 Latest Version 2026 (Anti-Ban)',
			keywords: 'GB WhatsApp Download, GB WhatsApp APK',
			description:
				'Download GB WhatsApp APK V18.80 latest version with Anti-Ban, Ghost Mode, privacy controls, custom themes, and more features for Android.',
			link: [
				{
					rel: 'canonical',
					href: canonical('/'),
				},
			],
		},
		component: Home,
	},
	{
		path: '/download',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Download GB WhatsApp  – Latest APK  & Requirements',
			keywords: 'GB WhatsApp APK Download',
			description:
				'Download the GB WhatsApp APK file and check the latest version, APK size, Android requirements, installation details and available features.',
			link: [
				{
					rel: 'canonical',
					href: canonical('/download/'),
				},
			],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/contact-us',
		name: 'en-contact',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Contact Us - GBwtsapp',
			keywords: 'GB WhatsApp contact, gbwtsapp contact',
			description:
				'Contact GB WhatsApp for website feedback, content corrections, technical questions, or other inquiries about our website.',
			legalKey: 'contact',
			link: [
				{
					rel: 'canonical',
					href: canonical('/contact-us/'),
				},
			],
		},
		component: () => import('@/views/legal.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'en-privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy - GBwtsapp',
			keywords: 'GB WhatsApp privacy policy, gbwtsapp privacy policy',
			description:
				'Read the GB WhatsApp Privacy Policy to understand how our website handles information, cookies, analytics, advertising, and user privacy.',
			legalKey: 'privacy',
			link: [
				{
					rel: 'canonical',
					href: canonical('/privacy-policy/'),
				},
			],
		},
		component: () => import('@/views/legal.vue'),
	},
	{
		path: '/terms-of-use',
		name: 'en-terms',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Terms of Use - GBwtsapp',
			keywords: 'GB WhatsApp terms of use, gbwtsapp terms',
			description:
				'Read the GB WhatsApp Terms of Use covering website content, downloads, external links, user responsibilities, and limitations of liability.',
			legalKey: 'terms',
			link: [
				{
					rel: 'canonical',
					href: canonical('/terms-of-use/'),
				},
			],
		},
		component: () => import('@/views/legal.vue'),
	},
	{
		path: '/disclaimer',
		name: 'en-disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer - GBwtsapp',
			keywords: 'GB WhatsApp disclaimer, gbwtsapp disclaimer',
			description:
				'Read the GB WhatsApp Disclaimer for information about third-party apps, APK downloads, trademarks, external links, and website content.',
			legalKey: 'disclaimer',
			link: [
				{
					rel: 'canonical',
					href: canonical('/disclaimer/'),
				},
			],
		},
		component: () => import('@/views/legal.vue'),
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes: constRoutesPc,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			return { x: 0, y: 0 }
		},
	})
}
